<template>
  <div class="mb48 orderSearch tms-style">
    <el-card class="mtf1">
      <el-form ref="searchForm" :model="searchForm" :inline="true" label-width="100px" label-position="left" class="custom-el-form">
        <el-form-item :label="$t('SeaFreight.CustomerCode')" style="width: 24%">
          <el-input v-model="searchForm.Customer_No" size="small" class="custom-input" />
        </el-form-item>
        <el-form-item :label="$t('SeaFreight.MWJobNo')" style="width: 24%">
          <el-input v-model="searchForm.Booking_No" size="small" class="custom-input" />
        </el-form-item>
        <el-form-item :label="$t('SeaFreight.RangeofBooking')" style="width: 28%">
          <el-date-picker v-model="searchForm.CreateInterval" type="daterange" range-separator="~" :start-placeholder="$t('SeaFreight.StartTime')" :end-placeholder="$t('SeaFreight.EndTime')" format="yyyy-MM-dd" value-format="yyyy-MM-dd" size="small" class="custom-input" :picker-options="pickerOptions" />
        </el-form-item>
        <el-form-item :label="$t('SeaFreight.MBHBNo')" label-width="110px" style="width: 24%">
          <el-input v-model="searchForm.MBL_HBL_NO" size="small" class="custom-input" />
        </el-form-item>
        <el-form-item :label="$t('SeaFreight.PortofLoading')" style="width: 24%">
          <RemoteSelect :value.sync="searchForm.POL" :width="400" @remoteQuery="remoteQueryPOL" @remoteSelect="remoteSelect">
            <template #columns>
              <el-table-column width="100" property="seaportCode" :label="$t('SeaFreight.Code')" />
              <el-table-column :property="$t('SeaFreight.seaport')" :label="$t('SeaFreight.Name')" />
            </template>
          </RemoteSelect>
        </el-form-item>
        <el-form-item :label="$t('SeaFreight.PortofDestination')" style="width: 24%">
          <RemoteSelect :value.sync="searchForm.POD" :width="400" @remoteQuery="remoteQueryPOD" @remoteSelect="remoteSelect">
            <template #columns>
              <el-table-column width="100" property="seaportCode" :label="$t('SeaFreight.Code')" />
              <el-table-column :property="$t('SeaFreight.seaport')" :label="$t('SeaFreight.Name')" />
            </template>
          </RemoteSelect>
        </el-form-item>
        <div class="custom-flex-center" style="margin-top: 20px">
          <el-button type="primary" size="small" class="buttonSize" icon="el-icon-search" :loading="fullscreenLoading" @click="query">{{ $t('SeaFreight.Query') }}</el-button>
          <el-button size="small" class="search buttonSize" icon="el-icon-refresh-right" :loading="fullscreenLoading" @click="empty">{{ $t('SeaFreight.Reset') }}</el-button>
          <el-button size="small" class="search buttonSize" icon="el-icon-download" :loading="fullscreenLoading" @click="exportData">{{ $t('SeaFreight.Export') }}</el-button>
        </div>
      </el-form>
    </el-card>
    <el-card class="mt10">
      <div class="custom-flex-space-between mb20">
        <div style=" font-size: 16px">{{ $t('SeaFreight.ViewDetails') }}</div>
        <el-tooltip class="showType" effect="dark" :open-delay="500" :content="showType ? $t('SeaFreight.SwitchToList'):$t('SeaFreight.SwitchToCard')" placement="bottom">
          <img v-if="showType" src="@/assets/fms/order_list_card.png" @click="showTypeChange">
          <img v-else src="@/assets/fms/order_list_table.png" @click="showTypeChange">
        </el-tooltip>
      </div>
      <el-collapse v-if="showType" v-model="activeNames" v-loading="loading" class="custom-el-collapse el-collapse">
        <el-collapse-item v-for="i in dataList" :key="i.Booking_No" :name="i.Booking_No">
          <div slot="title" class="w100">
            <div class="order-title custom-flex-space-between" @click="toggleCollapse(i)">
              <img src="@/assets/fms/订单.png" class="order-img">
              <div style="flex:1">
                <div class="custom-flex-space-between">
                  <div class="inline-block ml18" style="width:30%">
                    <span class="order-label">{{ $t('SeaFreight.CustomerCode')+' : ' }}</span>
                    <span class="order-text">{{ i.Customer_No }}</span>
                  </div>
                  <div class="inline-block" style="width:30%">
                    <span class="order-label">{{ $t('SeaFreight.BookingNumber')+' : ' }}</span>
                    <span class="order-text-booking">{{ i.Booking_No }}</span>
                  </div>
                  <div class="inline-block " style="width:40%">
                    <span class="order-label">{{ $t('SeaFreight.DateofBooking')+' : ' }}</span>
                    <span class="order-text">{{ convertYMD(i.CreateDT) }}</span>
                  </div>
                </div>
                <div class="custom-flex-space-between">
                  <div class="inline-block ml18" style="width:30%">
                    <span class="order-label">{{ $t('SeaFreight.PortofLoading')+' : ' }}</span>
                    <span class="order-text">{{ getUpper(i.POL) }}/{{ getUpper(i.POL_Name) }}</span>
                  </div>
                  <div class="inline-block" style="width:30%">
                    <span class="order-label">{{ $t('SeaFreight.PortofDestination')+' : ' }}</span>
                    <span class="order-text">{{ getUpper(i.POD) }}/{{ getUpper(i.POD_Name) }}</span>
                  </div>
                  <div class="inline-block" style="width:40%">
                    <span class="order-label">{{ $t('SeaFreight.DeliveryNoteNumber')+' : ' }}</span>
                    <span class="order-text">{{ i.MBL_NO }}</span>
                  </div>
                </div>

                <!-- <div class="inline-block " style="width:16%">
                <span class="order-label">{{ $t('SeaFreight.ServiceType')+' : ' }}</span>
                <span class="order-text-jobtype">{{ i.Job_Type+'('+EnumJobTypeValueLocal('JobTypeEnum',i.Job_Type, 'zh')+')' }}</span>
              </div> -->
              </div>
              <span class="collapsed">{{ i.collapsed ? $t('SeaFreight.Collapse') : $t('SeaFreight.ViewDetails') }}</span>
            </div>
          </div>
          <div class="custom-flex-space-between">
            <div class="w100 order-title-wrap">
              <el-row class="w100" style="display: flex;margin-left: 17px">
                <div style="width:50%">
                  <el-row class="details-text">
                    <el-col class="details-label">{{ $t('SeaFreight.DeliveryAddress')+' : ' }}</el-col>
                    <el-col class="details-value">
                      <el-tooltip :content="addressTooltip(i.Delivery_AddressList,'2')" effect="dark" :disabled="false" placement="top-start" :enterable="false">
                        <span> {{ addressTooltip(i.Delivery_AddressList,'1') }}</span>
                      </el-tooltip>
                    </el-col>
                  </el-row>
                  <!-- <el-row class="details-title">
                      <el-col class="w100">{{ $t('SeaFreight.PortofLoadingDetails') }}</el-col>
                    </el-row> -->
                  <!-- <el-row class="details-text">
                      <el-col class="details-label">{{ $t('SeaFreight.PortofLoading')+' : ' }}</el-col>
                      <el-col class="details-value">{{ getUpper(i.POL_Name) }}</el-col>
                    </el-row> -->
                  <!-- <el-row class="details-text">
                      <el-col class="details-label">{{ $t('SeaFreight.DeliveryNoteNumber')+' : ' }}</el-col>
                      <el-col class="details-value">{{ i.MBL_NO }}</el-col>
                    </el-row> -->
                  <el-row class="details-text" v-if="i.Job_Type==='LI'">
                    <el-col class="details-label">{{ $t('SeaFreight.TotalNumberOfPackage')+' : ' }}</el-col>
                    <el-col class="details-value">{{ i.Pkgs_Num +' ('+(i.Pkgs_Unit || '')+')' }}</el-col>
                  </el-row>
                  <el-row class="details-text" v-if="i.Job_Type==='LI'">
                    <el-col class="details-label">{{ $t('SeaFreight.GrossWeight')+'(KGS) : ' }}</el-col>
                    <el-col class="details-value">{{ ext.roundFixed(i.GW,2) }}</el-col>
                  </el-row>
                  <el-row class="details-text" v-if="i.Job_Type==='LI'">
                    <el-col class="details-label">{{ $t('SeaFreight.CBM')+'(CBM) : ' }}</el-col>
                    <el-col class="details-value">{{ ext.roundFixed(i.CBM,2) }}</el-col>
                  </el-row>
                </div>
                <div style="width:50%">
                  <!-- <el-row class="details-title">
                    <el-col class="w100">{{ $t('SeaFreight.PortofDestinationDetails') }}</el-col>
                  </el-row> -->
                  <!-- <el-row class="details-text">
                    <el-col class="details-label">{{ $t('SeaFreight.PortofDestination')+' : ' }}</el-col>
                    <el-col class="details-value">{{ getUpper(i.POD_Name) }}</el-col>
                  </el-row> -->

                  <el-row class="details-text" v-if="i.Job_Type==='OI'">
                    <el-col class="details-label">{{ $t('SeaFreight.TEU')+' : ' }}</el-col>
                    <el-col class="details-value">
                      <el-tooltip :content="String(i.Container_QuantityCount)" placement="top-start" effect="dark">
                        <div class="text-content">{{ i.Container_QuantityCount }}</div>
                      </el-tooltip>
                    </el-col>
                  </el-row>
                </div>
                <!-- <div style="width:34%">
                  <el-row class="details-title">
                    <el-col class="w100">{{ $t('SeaFreight.DeliveryAddressInformation') }}</el-col>
                  </el-row>

                </div> -->
                <div style="">
                  <el-button type="primary" class="custom-el-button" size="small" style="display: block; width: 102px" @click="downloadAttachment(i)">
                    <span><img src="@/assets/fms/下载.png">
                      {{ $t('SeaFreight.DownloadAttachment') }}</span>
                  </el-button>
                </div>
              </el-row>
              <el-row class="w100">
                <OrderStep :statu-list="getMilestoneData(i)" imgLayout="bottom" />
              </el-row>
            </div>
          </div>
        </el-collapse-item>
      </el-collapse>
      <div v-else style="padding: 0px 20px 20px 20px">
        <el-table ref="orderTable" v-loading="loading" :data="dataList">
          <!-- :row-class-name="tableRowClassName" -->
          <el-table-column type="index" width="80" :index="getIndex" :label="$t('SeaFreight.SerialNumber')" />
          <el-table-column prop="Customer_No" width="150" :label="$t('SeaFreight.CustomerCode')" />
          <el-table-column prop="Booking_No" width="150" :label="$t('SeaFreight.MWJobNo')" />
          <el-table-column prop="MBL_NO" width="180" :label="$t('SeaFreight.DeliveryNoteNumber')" />
          <el-table-column prop="AUDIT_TYPE" width="150" :label="$t('SeaFreight.OrderStatus')" :formatter="(row)=>{
              return orderNode(row)
            }" />
          <!-- <el-table-column
            prop="Job_Type"
            width="100"
            :label="$t('SeaFreight.ServiceType')"
            :formatter="(row)=>{
              return row.Job_Type+'('+EnumJobTypeValueLocal('JobTypeEnum',row.Job_Type,'zh')+')'
            }"
          /> -->
          <el-table-column :label="$t('SeaFreight.DateofBooking')" prop="CreateDT" width="150" :formatter="(row)=>{
              return convertYMD(row.CreateDT)
            }" />
          <el-table-column prop="CBM" width="120" :label="$t('SeaFreight.CBM')+'(CBM)'" />
          <el-table-column prop="POL" width="200" :label="$t('SeaFreight.PortofLoading')" :formatter="(row)=>{
              return getUpper(row.POL)+'/'+getUpper(row.POL_Name)
            }" />
          <el-table-column prop="POD" width="200" :label="$t('SeaFreight.PortofDestination')" :formatter="(row)=>{
              return getUpper(row.POD)+'/'+getUpper(row.POD_Name)
            }" />
          <el-table-column prop="Delivery_AddressList" width="320" :label="$t('SeaFreight.DeliveryAddress')">
            <template slot-scope="scope">
              <el-tooltip :content="addressTooltip(scope.row.Delivery_AddressList,'2')" effect="dark" :disabled="false" placement="top-start" :enterable="false">
                <span>{{ addressTooltip(scope.row.Delivery_AddressList,'1') }}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column :label="$t('SeaFreight.Operate')" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="downloadAttachment(scope.row)">{{ $t('SeaFreight.DownloadAttachment') }}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-card>
    <div class="footPage">
      <el-pagination class="custom-el-pagination floatR" background layout="sizes, prev, pager, next" :current-page.sync="curPageIndex" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="listTotalCount" @size-change="pageSizeChangeHandle" @current-change="curPageChangeHandle" />
    </div>
    <OceanfileDialog v-if="oceanfileDialogShow" :visible.sync="oceanfileDialogShow" :title="curTitle" :cur-row="curRow" job-type="OI" />
  </div>
</template>
<script>
import { getOceanImportPageList } from '@/api/ocean/order/oi/index'
import { GetSeaProts } from '@/api/ocean/order/oe/index'
import OrderStep from '@/components/fms/orderStep/index.vue'
import { convertYMD, conversionTime, parseTime, dateAdds } from '@/utils/index'
import { ISStr, EnumJobTypeValueLocal } from '@/utils/isClass'
import OceanfileDialog from '@/components/fms/Dialog/oceanfileDialog.vue'
import { exportToExcel } from '@/vendor/Export2Excel.js'
import { tableRowClassName } from '@/utils/fms/tableClass'
import RemoteSelect from '@/components/fms/remoteSelect.vue'
import i18n from '@/i18n/i18n'
const searchForm = {
  Customer_Code: '', // 201808017544
  Booking_No: '', // OI00SH230501761
  Customer_No: '',
  MBL_HBL_NO: '',
  POL: '',
  POD: '',
  CreateInterval: [
    parseTime(dateAdds(new Date(), -30, 'd'), '{y}-{m}-{d}'),
    parseTime(new Date(), '{y}-{m}-{d}')
  ]
}
export default {
  components: { OrderStep, OceanfileDialog, RemoteSelect },
  props: {
    customerCode: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      EnumJobTypeValueLocal,
      ISStr,
      convertYMD,
      conversionTime,
      tableRowClassName,
      loading: false,
      showType: true,
      fullscreenLoading: false,
      activeNames: [],
      dataList: [],
      searchForm: JSON.parse(JSON.stringify(searchForm)),
      searchSendCarForm: JSON.parse(JSON.stringify(searchForm)), // 搜索条件
      listTotalCount: 0,
      curPageIndex: 1,
      pageIndex: 1,
      pageSize: 10,
      oceanfileDialogShow: false,
      curTitle: i18n.t('SeaFreight.DownloadAttachment'),
      curRow: {},
      disabledDateRange: [],
      pickerOptions: {
        disabledDate: (time) => {
          if (this.disabledDateRange && this.disabledDateRange.length > 0) {
            return (
              time.getTime() < this.disabledDateRange[0].getTime() ||
              time.getTime() > this.disabledDateRange[1].getTime()
            )
          } else {
            return false
          }
        },
        onPick: (picks) => {
          if (picks.maxDate) {
            this.disabledDateRange = []
          } else {
            this.disabledDateRange = [
              dateAdds(picks.minDate, -30, 'd'),
              dateAdds(picks.minDate, 30, 'd')
            ]
          }
        }
      }
    }
  },
  computed: {},
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.getList()
    },
    getIndex(index) {
      return (this.pageIndex - 1) * this.pageSize + index + 1
    },
    showTypeChange() {
      this.showType = !this.showType
    },
    /**  查询 */
    query() {
      this.fullscreenLoading = true
      var _this = this
      this.pageIndex = 1
      this.searchSendCarForm = JSON.parse(JSON.stringify(_this.searchForm))
      this.getList()
    },
    /**  清空 */
    empty() {
      this.searchForm = JSON.parse(JSON.stringify(searchForm))
      this.searchSendCarForm = JSON.parse(JSON.stringify(searchForm))
    },
    /**  列表查询 */
    getList() {
      this.loading = true
      const pagination = {}
      pagination.pageIndex = this.pageIndex
      pagination.pagesize = this.pageSize
      pagination.sort = 'CreateDT'
      const data = {}
      this.searchSendCarForm.Customer_Code = this.customerCode
      data.pagination = JSON.stringify(pagination)
      data.queryJson = JSON.stringify(this.searchSendCarForm)
      getOceanImportPageList(data)
        .then((res) => {
          var data = JSON.parse(res.data)
          this.listTotalCount = data?.total
          const result = data?.rows ?? []
          this.dataList = result
          this.activeNames = []
          this.curPageIndex = this.pageIndex
          this.loading = false
          this.fullscreenLoading = false
        })
        .catch((err) => {
          this.loading = false
          this.fullscreenLoading = false
          console.log(err)
        })
    },
    pageSizeChangeHandle(size) {
      this.pageSize = size
      this.pageIndex = 1
      this.getList()
    },
    curPageChangeHandle(pageIndex) {
      this.pageIndex = pageIndex
      this.getList()
    },
    /**  节点 */
    getMilestoneData(item) {
      const data = []
      try {
        // ATA时间为空时, 当前时间 >= ETA, ATA = ETA
        // if (ISStr(item.ATATime) && !ISStr(item.ETATime)) {
        //   const etatime = convertYMD(item.ETATime)
        //   const getDate = convertYMD(new Date())
        //   if ( getDate >= etatime) {
        //     item.ATATime = item.ETATime
        //   }
        // }
        data.push({
          Name: i18n.t('SeaFreight.ReceivingOrders'),
          EventDT: this.milestoneTime(item.ReceivingOrdersTime),
          OpenImg: require('@/assets/fms/接单.png'),
          ShutImg: require('@/assets/fms/接单—灰.png')
        })
        data.push({
          Name: 'ETA',
          EventDT: convertYMD(item.ETATime), //this.milestoneTime(item.ETATime),
          OpenImg: require('@/assets/fms/ETA.png'),
          ShutImg: require('@/assets/fms/ETA—灰.png')
        })
        // data.push({ Name: '危申报', EventDT: this.milestoneTime(item.DangerousDeclarationTime) })
        data.push({
          Name: 'ATA',
          EventDT: this.milestoneTime(item.ATATime),
          OpenImg: require('@/assets/fms/签收.png'),
          ShutImg: require('@/assets/fms/签收—灰.png')
        })
        // 有报关服务显示报关节点 模糊匹配
        if (
          item.ServiceRequest?.includes('报关') ||
          item.ServiceRequest?.includes('空罐备案')
        ) {
          data.push({
            Name: i18n.t('SeaFreight.CustomsRelease'),
            EventDT: this.milestoneTime(item.CustomsClearanceTime),
            OpenImg: require('@/assets/fms/放行（海）.png'),
            ShutImg: require('@/assets/fms/放行—灰.png')
          })
        }
        // 有送货服务显示送货节点 模糊匹配
        if (item.ServiceRequest?.includes('送货')) {
          data.push({
            Name: i18n.t('SeaFreight.DeliveryDate'),
            EventDT: this.milestoneTime(item.BusinessCompletionTime),
            OpenImg: require('@/assets/fms/开航.png'),
            ShutImg: require('@/assets/fms/开航—灰.png')
          })
        }
        return data
      } catch (error) {
        return data
      }
    },
    /** 送货地址提示 */
    addressTooltip(address, type) {
      if (ISStr(address)) {
        return ''
      }
      var addressList = address.split(',')
      if (type === '1') {
        return addressList[0]
      } else if (type === '2') {
        return i18n.t('SeaFreight.DeliveryAddress') + ':' + addressList
      }
    },
    /** 附件下载 */
    downloadAttachment(row) {
      this.curTitle =
        i18n.t('SeaFreight.DownloadAttachment') + ' ' + row.Booking_No
      this.curRow = row
      this.oceanfileDialogShow = true
    },
    /** milestone时间大于当前时间的不显示 */
    milestoneTime(time) {
      const contime = convertYMD(time)
      if (ISStr(contime)) return null
      const getDate = convertYMD(new Date())
      if (contime <= getDate) {
        return contime
      } else {
        return null
      }
    },
    /** 导出 */
    exportData() {
      this.loading = true
      this.fullscreenLoading = true
      const pagination = {}
      // 导出全部查询数据
      pagination.pageIndex = 1
      pagination.pagesize = this.listTotalCount
      pagination.sort = 'CreateDT'
      const data = {}
      this.searchSendCarForm.Customer_Code = this.customerCode
      data.pagination = JSON.stringify(pagination)
      data.queryJson = JSON.stringify(this.searchSendCarForm)
      const currentLang = this?.$ls?.get('lang') || 'zh'
      var SecondaryMenu = '海运'
      if (currentLang === 'en') {
        SecondaryMenu = 'Ocean Freight'
      }
      getOceanImportPageList(data)
        .then((res) => {
          var data = JSON.parse(res.data)
          this.listTotalCount = data?.total
          const result = data?.rows ?? []
          // 转换数据为工作表对象
          var dataList = result.map((x) => {
            var data = {
              Booking_No: x.Booking_No,
              Customer_No: x.Customer_No,
              MBL_NO: x.MBL_NO,
              AUDIT_TYPE: this.orderNode(x),
              // Job_Type: x.Job_Type + '(' + EnumJobTypeValueLocal('JobTypeEnum', x.Job_Type, currentLang) + ')',
              CreateDT: convertYMD(x.CreateDT),
              Pkgs_Num: x.Pkgs_Num,
              Pkgs_Unit: x.Pkgs_Unit,
              GW: x.GW,
              CBM: x.CBM,
              Container_QuantityCount: x.Container_QuantityCount,
              POL: x.POL?.toUpperCase() + '/' + x.POL_Name?.toUpperCase(),
              POD: x.POD?.toUpperCase() + '/' + x.POD_Name?.toUpperCase(),
              Delivery_AddressList: x.Delivery_AddressList,

              ReceivingOrdersTime: this.milestoneTime(x.ReceivingOrdersTime),
              ETATime: convertYMD(x.ETATime), //this.milestoneTime(x.ETATime),
              // DangerousDeclarationTime: this.milestoneTime(x.DangerousDeclarationTime),
              ATATime: this.milestoneTime(x.ATATime)
              // CustomsClearanceTime: this.milestoneTime(x.CustomsClearanceTime),
              // BusinessCompletionTime: this.milestoneTime(x.BusinessCompletionTime)
            }
            // 有报关服务显示报关节点
            if (
              x.ServiceRequest?.includes('报关') ||
              x.ServiceRequest?.includes('空罐备案')
            ) {
              data.CustomsClearanceTime = this.milestoneTime(
                x.CustomsClearanceTime
              )
            } else {
              data.CustomsClearanceTime = '/'
            }
            // 有送货服务显示送货节点
            if (x.ServiceRequest?.includes('送货')) {
              data.BusinessCompletionTime = this.milestoneTime(
                x.BusinessCompletionTime
              )
            } else {
              data.BusinessCompletionTime = '/'
            }
            return data
          })
          var column = [
            { lable: i18n.t('SeaFreight.CustomerCode'), width: 20 }, // Customer_No
            { lable: i18n.t('SeaFreight.MWJobNo'), width: 20 }, // Booking_No
            { lable: i18n.t('SeaFreight.DeliveryNoteNumber'), width: 20 }, // MBL_NO
            { lable: i18n.t('SeaFreight.OrderStatus'), width: 15 }, // AUDIT_TYPE
            // { lable: i18n.t('SeaFreight.ServiceType'), width: 15 }, // Job_Type
            { lable: i18n.t('SeaFreight.DateofBooking'), width: 15 }, // CreateDT
            { lable: i18n.t('SeaFreight.NumberOfPieces'), width: 15 }, // Pkgs_Num
            { lable: i18n.t('SeaFreight.Unit'), width: 15 }, // Pkgs_Unit
            { lable: i18n.t('SeaFreight.GrossWeight') + '(KGS)', width: 15 }, // GW
            { lable: i18n.t('SeaFreight.CBM') + '(CBM)', width: 15 }, // CBM
            { lable: i18n.t('SeaFreight.TEU'), width: 15 }, // Container_QuantityCount
            { lable: i18n.t('SeaFreight.PortofLoading'), width: 20 }, // POL
            { lable: i18n.t('SeaFreight.PortofDestination'), width: 20 }, // POD_Name
            { lable: i18n.t('SeaFreight.DeliveryAddress'), width: 50 }, // Delivery_AddressList

            { lable: i18n.t('SeaFreight.ReceivingOrders'), width: 20 }, // ReceivingOrdersTime
            { lable: 'ETA', width: 20 }, // ETATime
            // { lable: '危申报', width: 20 }, // DangerousDeclarationTime
            { lable: 'ATA', width: 20 }, // ATATime
            { lable: i18n.t('SeaFreight.CustomsRelease'), width: 20 }, // CustomsClearanceTime
            { lable: i18n.t('SeaFreight.DeliveryDate'), width: 20 } // BusinessCompletionTime
          ]
          var fileName =
            SecondaryMenu +
            '_' +
            i18n.t('SeaFreight.FreightImport') +
            '-' +
            this.getNowDate()
          exportToExcel({ column, dataList, filename: fileName })
          this.loading = false
          this.fullscreenLoading = false
        })
        .catch((err) => {
          this.loading = false
          this.fullscreenLoading = false
          console.log(err)
        })
    },
    getNowDate() {
      // 创建一个新的日期对象
      var currentDate = new Date()
      // 获取年份
      var year = currentDate.getFullYear()
      // 获取月份，注意月份从0开始，所以需要加1
      var month = currentDate.getMonth() + 1
      month = month < 10 ? '0' + month : month // 如果月份小于10，在前面添加0
      // 获取日期
      var day = currentDate.getDate()
      day = day < 10 ? '0' + day : day // 如果日期小于10，在前面添加0
      // 将年份、月份和日期组合成一个字符串
      var formattedDate = year + '' + month + '' + day
      return formattedDate
    },
    /** 根据订单节点显示订单状态 */
    orderNode(row) {
      // milestone时间大于当前时间的不显示，订单状态也需要不显示
      const getDate = convertYMD(new Date())
      if (
        !ISStr(row.BusinessCompletionTime) &&
        row.ServiceRequest?.includes('送货') &&
        convertYMD(row.BusinessCompletionTime) <= getDate
      ) {
        return i18n.t('SeaFreight.DeliverGoods')
      } else if (
        !ISStr(row.CustomsClearanceTime) &&
        row.ServiceRequest?.includes('报关') &&
        convertYMD(row.CustomsClearanceTime) <= getDate
      ) {
        return i18n.t('SeaFreight.CustomsRelease')
      } else if (!ISStr(row.ATATime) && convertYMD(row.ATATime) <= getDate) {
        return 'ATA'
      } else if (!ISStr(row.ETATime) ) {//&& convertYMD(row.ETATime) <= getDate
        return 'ETA'
      } else if (
        !ISStr(row.ReceivingOrdersTime) &&
        convertYMD(row.ReceivingOrdersTime) <= getDate
      ) {
        return i18n.t('SeaFreight.ReceivingOrders')
      } else {
        return ''
      }
    },
    /**  点击时切换展开和收缩状态 */
    toggleCollapse(row) {
      row.collapsed = !row.collapsed
    },
    formatUpper(row, column) {
      if (row[column.property]) {
        return row[column.property].toUpperCase()
      } else return ''
    },
    getUpper(i) {
      if (i) return i.toUpperCase()
      else return ''
    },
    async remoteQueryPOL(query, call) {
      const res = await GetSeaProts({ KeyWord: query, portType: '国际港口' })
      if (call) {
        if (res.isSuccess) {
          call(res.data)
        } else {
          call([])
        }
      }
    },
    async remoteQueryPOD(query, call) {
      const res = await GetSeaProts({ KeyWord: query, portType: '国际港口' })
      if (call) {
        if (res.isSuccess) {
          call(res.data)
        } else {
          call([])
        }
      }
    },
    remoteSelect(row, call) {
      if (call) {
        call(row.seaportCode)
      }
    }
  }
}
</script>
<style scoped>
@import '~@/styles/fms/tableClass.scss';
.orderSearch >>> .el-date-editor .el-range-separator {
  width: initial;
  display: block !important;
}
.orderSearch >>> .el-form-item {
  margin-bottom: initial;
}
.orderSearch >>> .el-table .el-table__cell {
  padding: initial;
}

/* 公共样式提取至内部 开始*/
.custom-input >>> .el-input__inner {
  background: white;
  max-width: 500px;
}

.custom-input.el-input__inner >>> {
  background: white;
  max-width: 280px;
}

.custom-input.el-date-editor {
  background: white;
}
.custom-input.el-date-editor >>> .el-input__icon {
  display: none;
}
.el-date-editor >>> .el-range-input {
  background: white !important;
}
.custom-input >>> input {
  background: white;
  width: 100%;
}
.custom-el-collapse {
  border: 0;
}
.custom-el-collapse .el-collapse-item {
  border-radius: 8px;
  margin-bottom: 13px;
  box-shadow: none;
}
.custom-el-collapse .el-collapse-item >>> .el-collapse-item__header {
  margin: 0;
  font-size: 16px;
  font-weight: normal !important;
  height: auto;
  color: #111827;
  background-color: #fff !important;
  border: 0 !important;
  border-radius: 8px !important;
  line-height: initial;
}
.custom-el-collapse .el-collapse-item >>> .el-collapse-item__wrap {
  border-top: 1px solid #dcdee2;
  border-radius: 0 0 8px 8px;
}
.custom-el-collapse .el-collapse-item >>> .el-collapse-item__content {
  padding-bottom: 0px !important;
}
/* 公共样式提取至内部 结束 */

.mtf1 {
  margin-top: -1px;
  border-top: #fff;
}
.mtf1 >>> .el-card__body {
  padding: 20px 20px 20px 39px !important;
}
.mt10 {
  margin-top: 16px;
}
.mb20 {
  margin-bottom: 0px;
  padding: 10px 20px 10px 20px;
  border-radius: 4px 4px 0 0;
  border: 1px solid #ebeef5;
}
.ml18 {
  margin-left: 17px;
}
.mb48 {
  margin-bottom: 48px;
}
.w100 {
  width: 100%;
}
.floatR {
  float: right;
}
.el-collapse .divTitle {
  font-size: 14px;
  font-weight: 500;
  color: #4b5563;
}
.inline-block {
  display: inline-block;
}
.showType {
  width: 20px;
  height: 20px;
}
.footPage {
  z-index: 3;
  background-color: #fff;
  height: 48px;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 36px;
  padding: 8px 16px;
}
/* 样式改版 */
.text-content {
  overflow: hidden; /* 超出部分隐藏 */
  text-overflow: ellipsis; /* 使用省略号代替溢出部分 */
  white-space: nowrap; /* 不换行 */
}
.search {
  border: 1px solid #67b0c4 !important;
  border-color: #67b0c4 !important;
  color: #67b0c4;
}
.order-img {
  width: 24px !important;
  height: 30px !important;
  display: inline-block;
}
.mt10 >>> .el-card__body {
  padding: 0px !important;
}
.order-title {
  padding: 36px 45.5px 33px 32px;
  width: 100% !important;
}
.custom-el-collapse {
  background-color: aliceblue;
}
.order-label {
  font-size: 16px;
  font-family: Source Han Sans SC, Source Han Sans SC-Regular;
  font-weight: 500;
  text-align: left;
  color: #333333;
  line-height: 24px;
}
.order-text {
  font-size: 14px;
  font-family: Source Han Sans SC, Source Han Sans SC-Regular;
  font-weight: 400;
  text-align: left;
  color: #666666;
  line-height: 22px;
}
.order-text-booking {
  font-size: 14px;
  font-family: Source Han Sans SC, Source Han Sans SC-Regular;
  font-weight: 400;
  text-align: left;
  color: #67b0c4;
  border-radius: 6px;
  line-height: 22px;
}
.order-text-jobtype {
  font-size: 14px;
  font-family: Source Han Sans SC, Source Han Sans SC-Regular;
  font-weight: 400;
  text-align: left;
  line-height: 22px;
  background: #e8f3f6;
  color: #084156;
  border-radius: 6px;
  padding: 2px 10px 2px 10px;
}
.details-label {
  width: 110px;
  font-size: 16px;
  font-family: Source Han Sans SC, Source Han Sans SC-Bold;
  /* font-weight: 700; */
  text-align: left;
  color: #333333;
  line-height: 24px;
  /* margin-bottom: 13px; */
}
.details-value {
  width: calc(100% - 123px);
}
.details-text {
  font-size: 14px;
  font-family: Source Han Sans SC, Source Han Sans SC-Regular;
  font-weight: 400;
  text-align: left;
  color: #666666;
  line-height: 22px;
}
.details-title {
  font-size: 16px;
  font-family: Source Han Sans SC, Source Han Sans SC-Bold;
  font-weight: 700;
  text-align: left;
  color: #333333;
  line-height: 24px;
  margin-bottom: 13px;
}
.custom-el-button span {
  display: flex !important;
  justify-content: center;
  align-items: center;
  font-size: 14px;
}
.custom-el-button img {
  width: 14px;
  height: 14px;
  margin-right: 5px;
}
.custom-el-collapse >>> .el-collapse-item__arrow {
  display: none !important;
}
.collapsed {
  float: right;
  width: 56px;
  height: 20px;
  font-size: 14px;
  font-family: Source Han Sans SC, Source Han Sans SC-Medium;
  font-weight: 500;
  text-align: left;
  color: #67b0c4;
  line-height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.order-title-wrap {
  padding: 25px 28px 17px 27px !important;
}
.orderSearch >>> .el-card {
  border: 0px !important;
}
.buttonSize {
  font-size: 14px;
  font-weight: 500;
  border-radius: 4px;
}
.custom-el-form {
  padding: 0 16px;
}
.custom-el-form > .el-form-item {
  width: 25%;
  margin: 0;
  padding-top: 10px;
  padding-right: 10px;
  display: inline-flex;
}
.custom-el-form > .el-form-item >>> .el-form-item__content {
  flex: 1;
}
.custom-el-form >>> .el-input__inner {
  max-width: initial;
}
</style>
